@if (!withoutHeader()) {
  <div class="title">
    <ng-content select="[header]"/>
  </div>
}

<ng-content/>
